const marketing = {
  slug: 'f/marketing',
  submitQirLead: () => `${marketing.slug}/intelligence/quarterly-report/submit`,
  submitComplianceLead: () =>
    `${marketing.slug}/intelligence/compliance-report/submit`
}

export default marketing
